function handleContainer(removedClass, shownClass, container) {
  if (container !== null) {
    container.classList.remove(removedClass);
    container.classList.add(shownClass);
  }
}

// Delegate clicks so payment modals also work in AJAX quick views and theme editor sections.
document.addEventListener('click', (event) => {
  const control = event.target.closest('.installmentsTrigger, .closeInstallmentsModal, .backgroundDiv, .paymentType');
  if (!control) return;

  const scope = control.closest('[data-quickview-modal]') || control.closest('[data-section-id]') || document;
  const owner = control.dataset.paymentOwner || control.closest('.installmentsContainer')?.dataset.paymentOwner;
  if (!owner) return;

  const installments = Array.from(scope.querySelectorAll('.installmentsContainer'))
    .find((element) => element.dataset.paymentOwner === owner);
  const background = Array.from(scope.querySelectorAll('.backgroundDiv'))
    .find((element) => element.dataset.paymentOwner === owner);
  if (!installments || !background) return;
  event.preventDefault();

  if (control.matches('.installmentsTrigger')) {
    handleContainer('hiddenContainer', 'shownContainer', installments);
    handleContainer('hiddenDiv', 'shownDiv', background);
  } else if (control.matches('.closeInstallmentsModal, .backgroundDiv')) {
    handleContainer('shownContainer', 'hiddenContainer', installments);
    handleContainer('shownDiv', 'hiddenDiv', background);
  } else {
    installments.querySelectorAll('.paymentType').forEach((button) => {
      const active = button === control;
      handleContainer(active ? 'notFilled' : 'filled', active ? 'filled' : 'notFilled', button.querySelector('svg'));
    });
    installments.querySelectorAll('.tab').forEach((tab) => {
      const active = tab.dataset.index === control.dataset.index;
      handleContainer(active ? 'hiddenContainer' : 'shownContainer', active ? 'shownContainer' : 'hiddenContainer', tab);
    });
  }
});

// Keep the custom summary and payment table in sync with the selected variant.
document.addEventListener('theme:variant:change', (event) => {
  const scope = event.target.closest('[data-quickview-modal]') || event.target.closest('[data-section-id]');
  if (!scope) return;

  const variant = event.detail.variant;
  const money = (cents) => new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL',
  }).format(Math.round(cents) / 100);

  scope.querySelectorAll('[data-installment-summary], [data-installment-options]').forEach((element) => {
    element.hidden = !variant;
    if (!variant) return;

    const price = variant.price;
    const minimum = Number(element.dataset.installmentMinimum);
    const maximum = Number(element.dataset.installmentMaximum);
    const count = Math.max(1, Math.min(maximum, Math.floor(price / minimum)));
    const rates = JSON.parse(element.dataset.installmentRates);
    const total = (n) => Math.round(price * (1 + (rates[n] || 0) / 100));
    const amount = (n) => money(total(n) / n);

    if (element.hasAttribute('data-installment-summary')) {
      element.innerHTML = count > 1
        ? `em até <b>${count}x</b> de <b>${amount(count)}</b>${rates[count] ? '' : ' sem juros'} no cartão`
        : 'À vista no cartão';
      return;
    }

    const cashPrice = Math.round(price * (1 - Number(element.dataset.installmentCreditDiscount) / 100));
    element.innerHTML = Array.from({ length: count }, (_, index) => {
      const n = index + 1;
      return `<div class="installment${n % 2 ? ' even' : ''}">`
        + `<div>${n === 1 ? 'À vista no cartão:' : `${n}x de ${amount(n)}`}</div>`
        + `<div>Total: ${money(n === 1 ? cashPrice : total(n))}</div></div>`;
    }).join('');
  });
});
